import { EmailDeliveryService } from "./api";
import { EMAIL_DELIVERY_LIST } from "../../../types";
import { init, success, finish, error } from "services/common";

const emailDeliveryService = new EmailDeliveryService();

export const getDetails = (id) => {
  return async (dispatch) => {
    dispatch(init(EMAIL_DELIVERY_LIST.EMAIL_DELIVERY_LIST));
    const response = await emailDeliveryService.GetDetails(id);
    dispatch(finish(EMAIL_DELIVERY_LIST.EMAIL_DELIVERY_LIST));
    if (response.isSuccess) {
      dispatch(success(EMAIL_DELIVERY_LIST.EMAIL_DELIVERY_LIST, response.data));
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
  };
};
